window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');
require('bootstrap');
window.bsCustomFileInput = require('bs-custom-file-input');
require('select2');
// window.flatpickr = flatpickr = require('flatpickr');
window.AOS = require('aos');
require('card');
require('jquery-mask-plugin/dist/jquery.mask.min');

import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js"

import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'

Alpine.plugin(persist)
window.Alpine = Alpine
Alpine.start()

flatpickr.localize(Spanish);
flatpickr(".date-picker", {
    altInput: true,
    allowInput: true,
});
flatpickr(".datetime-picker", {
    altInput: false,
    enableTime: true,
    allowInput: true,
});


window.swal = require('sweetalert');

window.toastr = require('toastr');
window.toastr.options.closeButton = true;
window.toastr.options.closeMethod = 'fadeOut';
window.toastr.options.closeDuration = 300;
window.toastr.options.closeEasing = 'swing';

window.AOS.init();

if (window.location.pathname !== 'mi-cuenta') {
    window.sessionStorage.setItem('_x_tab', null);
}
